export { default } from "./MySharedResources";
